// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AthenaAsyncStatusFieldsJobStatus,
} from "./types";


export default __t.row({
  accountingItemTychoId: __t.uuid().name("accounting_item_tycho_id"),
  underwritableEntity: __t.uuid().name("underwritable_entity"),
  platform: __t.string(),
  rutterConnectionId: __t.string().name("rutter_connection_id"),
  get jobStatus() {
    return AthenaAsyncStatusFieldsJobStatus.name("job_status");
  },
});
